/**
 * Shared empty-state message so tabs present a consistent "no results" state.
 * `className` defaults to `no-results` but can be overridden to reuse a tab's
 * existing empty-state styling.
 * @param {{ message?: string, className?: string }} props
 */
export default function EmptyState({
  message = 'No results found',
  className = 'no-results',
}) {
  return <div className={className}>{message}</div>;
}
